export const Check = ({ color = 'white' }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path
      d="M1.5 4.80882C2.09459 5.22059 3.28378 6.35294 3.77027 7.125C4.36486 5.88971 5.87838 3.11029 7.5 1.875"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
